import { useTranslation } from "react-i18next";

import OverlayButton, { OverlayButtonProps } from "./OverlayButton";

// Props for DoubleSiteButton = own props + forwarded OverlayButton props
type DoubleSiteProps = {
  setDoubleSiteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
} & Omit<OverlayButtonProps, "onClick" | "icon" | "title">;
// Omit is optional, but useful if you don't want users to override these

const DoubleSiteButton: React.FC<DoubleSiteProps> = ({setDoubleSiteModalOpen, ...props }) => {
  const { t } = useTranslation();

  return (
    <OverlayButton
      onClick={() => setDoubleSiteModalOpen((prev: boolean) => !prev)}
      icon="Doppelseite"
      title={t('globus:description.doublePageView')}
      {...props}
    />
  );
};

export default DoubleSiteButton;
